import React, {ReactNode} from "react";
import {observer} from "mobx-react-lite";


import {FileUploadsManager} from "../../../stores/models/FileUploadsManager";
import {TaskReportFileMeta} from "../../../stores/taskLists/TaskReportModel";


import {ImageGalleryPreview} from "../ImageGalleryPreview";
import {DropBox} from "./DropBox";


import {useFileProvider} from "../../../stores/AppStateContext";
import {
    ImportMode,
} from "../../../actions/import/importFile";


import "./DragDropUpload.css";


interface DragDropUploadProps {
    fileUploadsManager: FileUploadsManager<TaskReportFileMeta>;
    accept?: string;
    className?: string;
    hint?: ReactNode;
    subHint?: ReactNode;
    mode?: ImportMode; // 'document' | 'image'
}

export const DragDropUpload = observer((
    {
        fileUploadsManager,
        accept = ".md, .doc, .docx, .txt, .rtf",
        className,
        hint,
        subHint,
        mode
    }: DragDropUploadProps
) => {
    const fileProvider = useFileProvider();
    
    const uploadFileHandle = () => {
        fileProvider?.uploadFile(
            {
                multiple: true,
                accept,
            },
            (newFiles) => {
                if (newFiles) {
                    fileUploadsManager.addFiles(newFiles)
                }
            }
        );
    };

    if (fileUploadsManager.entries.length > 0) {
        return (
            <ImageGalleryPreview
                urls={fileUploadsManager.entries.map(entry => ({
                    path: entry.meta?.path,
                    thumbPath: entry.meta?.thumbPath,
                    src: entry.previewUrl,
                }))}
                onAdd={uploadFileHandle}
                onRemove={fileUploadsManager.removeFileAt}
            />
        )
    }

    return (
        <DropBox
            className={className}
            mode={mode}
            addFiles={fileUploadsManager.addFiles}
            onClick={uploadFileHandle}
            hint={hint}
            subHint={subHint}
        />
    );
});
